/**
 * 模板市场-筛选条件容器
 * @author VenDream
 * @since 17/11/4
 */

import { connect } from 'react-redux';
import StoreFilters from 'components/store-filters';

import * as storeFilters from 'actions/store-filters';
import * as search from 'actions/search';

const {
  getStoreFilters,
  getOpenZoneFilters,
  setOpenSearchFilters,
  getOrgZoneFilters,
  setOrgZoneSearchFilters,
  setSubmitFilters,
  clearSubmitFilters,
  clearSingleSubmitFilters,
} = storeFilters;
const { addFilter, clearFilter } = search;

const mapStateToProps = state => {
  const { userInfo, storeFilters, storeTabs } = state;
  const {
    filters,
    submitFilters,
    openZoneFilters,
    openSearchFilters,
    orgZoneFilters,
    orgZoneSearchFilters,
  } = storeFilters;
  const { activeIndex, tabs } = storeTabs;
  const tabIndex = tabs.findIndex(n => n.index === activeIndex);
  const category = tabs[tabIndex === -1 ? 0 : tabIndex].name;
  return {
    user: userInfo,
    category,
    filters: filters[category] || [],
    openZoneFilters,
    openSearchFilters,
    submitFilters,
    clearFilter,
    orgZoneFilters,
    orgZoneSearchFilters,
  };
};

const mapDispatchToProps = dispatch => ({
  getOpenZoneFilters: () => dispatch(getOpenZoneFilters()),
  setOpenSearchFilters: filters => dispatch(setOpenSearchFilters(filters)),
  getOrgZoneFilters: orgId => dispatch(getOrgZoneFilters(orgId)),
  setOrgZoneSearchFilters: filters =>
    dispatch(setOrgZoneSearchFilters(filters)),
  getStoreFilters: category => dispatch(getStoreFilters(category)),
  setSubmitFilters: filters => dispatch(setSubmitFilters(filters)),
  clearSubmitFilters: () => dispatch(clearSubmitFilters()),
  addFilter: fliter => dispatch(addFilter(fliter)),
  clearFilter: (e, fliter) => dispatch(clearFilter(e, fliter)),
  clearSingleSubmitFilters: filter =>
    dispatch(clearSingleSubmitFilters(filter)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreFilters);
